import NotFoundError from "@/components/errors/not-found-error";
import { ROUTER_HELPERS } from "@/shared/constants/router";
import { createRoute } from "@tanstack/react-router";
import { errorLayoutRoute } from "../__root";

export const notFoundErrorRoute = createRoute({
  getParentRoute: () => errorLayoutRoute,
  path: ROUTER_HELPERS.error(404),
  component: NotFoundError,
});
